import {useState} from "react";
import DG_Modal from "../../../../custom/feedback/modal";
import Add from "./add";

const AddCustomerParent = ({visible, onCancel , onCustomers })=>{
    const [loading , setLoading] = useState(false)

    return (
        <DG_Modal visible={visible}
                  width={900}
                  onCancel={() => onCancel(false)}
                  title={"Tạo mới khách hàng "}
                  bodyStyle={{
                      minHeight: 100,
                      maxHeight: 600,
                      overflowY: "scroll",
                  }}
                  destroyOnClose={true}
                  okText={"Tạo mới"}
                  loading={loading} style={{ zIndex : 5000 }}>
            <Add onLoading={(value)=>setLoading(value)}
                 list={false}
                 onCancel={() => onCancel(false)}
                 onCustomers={onCustomers}
            />
        </DG_Modal>
    )
}

export default AddCustomerParent
